import { combineReducers } from "redux";
import currentViews from "./currentView";

export default combineReducers({ currentViews });